import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'app-mica-chat-campanas',
  imports: [],
  changeDetection: ChangeDetectionStrategy.Eager,
  template: `
    <div class="flex-1 flex items-center justify-center p-6">
      <div class="flex flex-col items-center gap-3 text-slate-400">
        <i class="bi bi-megaphone text-5xl"></i>
        <p class="text-sm font-medium">Campañas de WhatsApp</p>
        <p class="text-xs">Próximamente</p>
      </div>
    </div>
  `,
})
export class MicaChatCampanas {}
